/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";

export type RollupColor = "red" | "amber" | "green";

export const DOT_COLOR: Record<RollupColor, string> = {
    red: "#dc3545",
    amber: "#ffc107",
    green: "#198754",
};

export const DOT_LABEL: Record<RollupColor, string> = {
    red: "Open alerts / actions",
    amber: "Open advice only",
    green: "No open signals",
};

/** Path to the Signals page pre-filtered to a cell (query param read by SignalsPage). */
export const signalsCellPath = (locationId: string): string => `/signals?facility_location_id=${locationId}`;

interface RoomSignalDotProps {
    color?: RollupColor | string;
    onNavigate?: () => void;
    className?: string;
}

/** A per-room traffic-light dot (R8/R12). Clicking it navigates to the
 *  Signals page for that cell; `stopPropagation` keeps the surrounding
 *  card/row's room-detail navigation intact. */
export const RoomSignalDot: React.FC<RoomSignalDotProps> = ({ color, onNavigate, className }) => {
    if (!color || !(color in DOT_COLOR)) return null;
    const key = color as RollupColor;

    return (
        <span
            role="button"
            aria-label={DOT_LABEL[key]}
            title={DOT_LABEL[key]}
            className={className}
            onClick={(e) => {
                e.stopPropagation();
                onNavigate?.();
            }}
            css={css`
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background: ${DOT_COLOR[key]};
                cursor: pointer;
                box-shadow: 0 0 0 2px #fff;
            `}
        />
    );
};

export default RoomSignalDot;
